export const GROUP_START = 'group/group-start';
export const GROUP_SUCCESS = 'group/group-success';
export const GROUP_ERROR = 'group/group-error';